import React, { useState,useEffect } from "react";
import "../Header/Header.scss";
import kosmoslogo from "../../assets/kosmos-logo.png";
import { RiMenu3Fill } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import branchlogo from "../../assets/branchlogo1.png";
import branchlogo2 from "../../assets/branchlogo3.jpg";
import { IoClose } from "react-icons/io5";

const Header = () => {
  const location = useLocation();
  const ishomeActive =
    location.pathname === "/" || location.pathname.startsWith("/home");
  const isaccessoriesActive = location.pathname.startsWith("/accessories");
  const isregistrationActive = location.pathname.startsWith("/registration");
  const iscontactActive = location.pathname.startsWith("/contact");
  const isslotActive = location.pathname.startsWith("/slotpage");
  const [branch, setBranch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const dropdownShow = () => {
    setBranch(!branch);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]);

  return (
    <div>
      <nav className="nav-bar">
        <div className="logo">
  <Link to="/">
    <img src={kosmoslogo} alt="Kosmos Logo" />
  </Link>
</div>
        <div>
          <ul className={`menu-items ${menuOpen ? "open" : ""}`}>
            <li className={ishomeActive ? "active" : "list"}>
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: "white",
                  cursor: "pointer",
                }}
                onClick={()=>setMenuOpen(false)}
              >
                {" "}
                HOME
              </Link>
            </li>
            <li
              className={isaccessoriesActive ? "active" : "list"}
              onClick={dropdownShow}
            >
              BRANCHES
            </li>
            {branch && (
              <div
                className="branch-dropdown"
                style={{
                  background: "white",
                  color: "black",
                  padding: "15px",
                  fontSize: "1.2rem",
                  position: "absolute",
                  top: "95px",
                  marginLeft: "80px",
                }}
              >
                <li style={{ borderBottom: "1px solid gray", padding: "8px" }}>
                  <img src={branchlogo} alt="" width={30} height={30} />
                  <Link
                    to="/accessories"
                    state={{ branch: "KOSMOSRUWIBRANCH" }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      paddingLeft: "7px",
                    }}
                    onClick={()=>{setBranch(false);
                      setMenuOpen(false)
                    }}
                  >
                    KOSMOS RUWI BRANCH
                  </Link>
                </li>
                <li style={{ borderBottom: "1px solid gray", padding: "8px" }}>
                  <img src={branchlogo} alt="" width={30} height={30} />
                  <Link
                    to="/accessories"
                    state={{ branch: "KOSMOSGHALABRANCH" }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      paddingLeft: "7px",
                    }}
                    onClick={()=>{setBranch(false);
                      setMenuOpen(false)
                    }}
                  >
                    {" "}
                    KOSMOS GHALA BRANCH
                  </Link>
                </li>
                <li style={{ padding: "8px" }}>
                  <img src={branchlogo2} alt="" width={30} height={30} />
                  <Link
                    to="/accessories"
                    state={{ branch: "KOSMOSRIYAZBRANCH" }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      paddingLeft: "7px",
                    }}
                    onClick={()=>{setBranch(false);
                      setMenuOpen(false)
                    }
                  }
                  >
                    RIAZ SPORTS
                  </Link>
                </li>
              </div>
            )}

            <li className={isregistrationActive ? "active" : "list"}>
              <Link
                to="/kbaacademy"
                style={{ textDecoration: "none", color: "white" }}
              >
                KOSMOS BADMINTON ACADEMY
              </Link>
            </li>
            <li className={iscontactActive ? "active" : "list"}>
              <Link
                to="/contactus"
                style={{ textDecoration: "none", color: "white" }}
              >
                CONTACT US
              </Link>
            </li>
            <li className={isslotActive ? "slotActive" : "slotbtn"}>
              <Link
                style={{ textDecoration: "none", color: "white" }}
                to="/slotpage"
                 onClick={()=>setMenuOpen(false)}
              >
                BOOK YOUR SLOT
              </Link>
            </li>
          </ul>
        </div>
        <div className="menu-bar" onClick={toggleMenu}>
          {menuOpen ? (
            <IoClose size={24} color="white" />
          ) : (
            <RiMenu3Fill size={24} color="white" />
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
